<template>
  <div>
    <main>
      <div class="main-grid">
        <!-- TEXT LEFT -->
        <div class="column-one">
          <h2>{{ $t('programAdultTitle') }}</h2>
          <p>{{ $t('programIncluded') }}</p>
          <ul>
            <li v-for="(item, index) in $tm('adultList')" :key="index">{{ item }}</li>
          </ul>
          <p><strong>{{ $t('programDuration') }}</strong></p>
        </div>

        <!-- IMAGES RIGHT -->
<div class="image-right-top image-stack">
  <img
    src="/images/photo36.jpeg"
    :alt="$t('altFirstBoskarin')"
    class="responsive-img cropped-img"
  />
</div>

<!-- IMAGES LEFT -->
<div class="image-left-bottom image-stack">
  <img
    src="/images/photo37.jpeg"
    :alt="$t('altThirdBoskarin')"
    class="responsive-img cropped-img"
  />
  />
</div>


        <!-- TEXT RIGHT -->
        <div class="column-two">
          <h2>{{ $t('programChildrenTitle') }}</h2>
          <p>{{ $t('programIncluded') }}</p>
          <ul>
            <li v-for="(item, index) in $tm('childList')" :key="index">{{ item }}</li>
          </ul>
          <p><strong>{{ $t('programDuration') }}</strong></p>
        </div>
      </div>
    </main>
  </div>
</template>


<script setup>
import { useI18n } from 'vue-i18n'
import { useHead } from '@vueuse/head'
import { computed } from 'vue'

const { t } = useI18n()

const pageTitle = computed(() => t('meta.programPageTitle'))
const pageDescription = computed(() => t('meta.programPageDescription'))

useHead({
  title: pageTitle,
  meta: [
    {
      name: 'description',
      content: pageDescription,
    },
    {
      name: 'robots',
      content: 'index, follow',
    },
    {
      property: 'og:title',
      content: pageTitle,
    },
    {
      property: 'og:description',
      content: pageDescription,
    },
    {
      property: 'og:type',
      content: 'website',
    },
  ],
})
</script>


<style scoped>
.main-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 5rem 1.5rem; 
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 2rem;
}

.column-one {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  padding-top: 8rem;
  padding-left: 2rem;
}

.image-right-top {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

.image-left-bottom {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}

.column-two {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  padding-top: 8rem;
  padding-left: 2rem;
}

.responsive-img {
  width: 100%;
  height: auto;
  display: block;
}

.small-img {
  max-height: 450px;
  object-fit: cover;
}

@media (max-width: 768px) {
  .main-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
  }
  .column-one,
  .image-right-top,
  .image-left-bottom,
  .column-two {
    grid-column: 1 / 2;
    grid-row: auto;
  }
}

.image-stack {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.large-img {
  max-height: 450px;
  object-fit: cover;
}

.cropped-img {
  max-height: 500px;
  object-fit: cover;
  width: 100%;
  display: block;
}


</style>